module.exports = __WEBPACK_EXTERNAL_MODULE_3__;


//////////////////
// WEBPACK FOOTER
// external {"root":"_","amd":"underscore","commonjs2":"underscore","commonjs":"underscore"}
// module id = 3
// module chunks = 0